"use client";

import { NextIntlClientProvider } from "next-intl";
import type { TranslationsProviderProps } from "./TranslationsProvider.types";

export default function TranslationsProvider({
    locale,
    translations,
    children,
}: TranslationsProviderProps) {
    return (
        <NextIntlClientProvider locale={locale} messages={translations}>
            {children}
        </NextIntlClientProvider>
    );
}
